import React from 'react';
import { Form, FormSelect } from 'react-bootstrap'
import ModalCustom from '../../UI/modal'
import Button from '../../UI/button';

type Props = {
	show: boolean
	handleClose: () => void
}

const MoveActivityToTripModal = ({show, handleClose}: Props) => {
	const [selectedFolder, setSelectedFolder] = React.useState<string>('')
	
	return (
		<ModalCustom show={show} onHide={handleClose} title='Move link/activity to trip'>
			<Form className='move-to-trip-modal'>
				<p className='fs-6 font-libre' style={{marginBottom: '4px'}}>Select The Trip<span className='text-primary'>*</span></p>
				<FormSelect id='move-to-trip' style={{marginBottom: '24px'}} onChange={(e) => setSelectedFolder(e.target.value)}>
					<option disabled value='' selected>Select The Trip*</option>
					<option value='trip-1'>Trip 1</option>
					<option value='trip-2'>Trip 2</option>
					<option value='trip-3'>Trip 3</option>
				</FormSelect>
				<p className='fs-6 font-libre' style={{marginBottom: '4px'}}>Select The Folder</p>
				<FormSelect id='move-to-trip' style={{marginBottom: '24px'}} onChange={(e) => setSelectedFolder(e.target.value)}>
					<option disabled value='' selected>Select The Folder</option>
					<option value='trip-1'>Folder 1</option>
					<option value='trip-2'>Folder 2</option>
					<option value='trip-3'>Folder 3</option>
				</FormSelect>
				<Button disabled={selectedFolder === ''} variant='primary' className='mx-auto' width={142}>Move</Button>
			</Form>
		</ModalCustom>
	)
}
export default MoveActivityToTripModal